export class ApplicationLink {
  image: string = "";
  imageUrl: string = "";
  positions: string[] = [];
  description: string = "";
  name: string = "";
  title: string = "";
  state: number = 0;
  baseApplication: boolean = false;
  id: string = "00000000-0000-0000-0000-000000000000";
  timeString: Date = new Date();
  fileImage: File = new File([], "default");
  mobile: boolean = true;
  desktop: boolean = true;
  applicationUrls: ApplicationLinkByLocation[] = [];
  isSameUrlForAllLocations: boolean = true;
  commonApplicationUrl: string = "";
}

export class ApplicationLinkByLocation {
  locationId: string = "00000000-0000-0000-0000-000000000000";
  applicationUrl: string = "";
}

export interface Application {
  id: string;
  application: number;
  mobile: boolean;
  desktop: boolean;
  title: string;
  url: string;
  imageUrl: string;
}
